module.exports = __webpack_public_path__ + "img/csr13.1ff19f37.jpg";